export default __webpack_public_path__ + "static/media/download.6a8eca3e.svg";